export default __webpack_public_path__ + "static/media/Blood-ritual Boots.5d926090.jpg";